import React, { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import AuthShell from './AuthShell';
import { TextField, PasswordField, ErrorBanner } from './fields';

const Login = () => {
  const { t } = useTranslation();
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Zaten girişliyse auth sayfasına gerek yok.
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!identifier.trim() || !password) {
      setError(t('auth.error.required'));
      return;
    }

    setError(null);
    setLoading(true);
    try {
      await login(identifier.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow={t('auth.login.eyebrow')}
      title={t('auth.login.title')}
      subtitle={t('auth.login.subtitle')}
      switchNode={
        <>
          {t('auth.toSignup.q')}
          <Link to="/signup">{t('auth.toSignup.link')}</Link>
        </>
      }
    >
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <ErrorBanner message={error} />

        <TextField
          id="identifier"
          label={t('auth.field.identifier')}
          type="text"
          inputMode="email"
          autoComplete="username"
          placeholder={t('auth.field.identifier.ph')}
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          autoFocus
        />

        <PasswordField
          id="password"
          label={t('auth.field.password')}
          autoComplete="current-password"
          placeholder={t('auth.field.password.ph')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" className="auth-submit" disabled={loading}>
          {loading && <span className="auth-spinner" />}
          {loading ? t('auth.action.loggingIn') : t('auth.action.login')}
        </button>
      </form>
    </AuthShell>
  );
};

export default Login;
